import { render, staticRenderFns } from "./myTypeLink.vue?vue&type=template&id=2bd3aa5e&functional=true&"
import script from "./myTypeLink.vue?vue&type=script&lang=js&"
export * from "./myTypeLink.vue?vue&type=script&lang=js&"
import style0 from "./myTypeLink.vue?vue&type=style&index=0&id=2bd3aa5e&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  true,
  null,
  null,
  null
  
)

export default component.exports